import {
  Button,
  ButtonVariant,
  Icon,
  IconIdentifier,
  Placement,
  Tooltip,
} from '@aus-platform/design-system';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { isNil } from 'lodash';
import {
  selectMap3dDataset,
  setActiveSidebarOption,
} from 'map-3d/shared/map-3d-slices';
import { useState } from 'react';
import { map3dSidebarItems } from '../../constants';
import { Map3DSidebarOption, SelectTerrainModal } from '../../shared';

export const GenerateDTMEmptyState: React.FC = () => {
  // useStates.
  const [isSelectTerrainModalOpen, setIsSelectTerrainModalOpen] =
    useState(false);

  // Selectors.
  const { selectedProject } = useAppSelector(selectMap3dDataset);

  // Dispatch.
  const dispatch = useAppDispatch();

  // Handlers.
  const handleOpenWorkspace = () => {
    const workspaceItem =
      map3dSidebarItems.find(
        (item) => item.cardProps.title === Map3DSidebarOption.Workspace,
      ) ?? map3dSidebarItems[0];

    dispatch(setActiveSidebarOption(workspaceItem));
  };

  const showSelectTerrainModal = () => setIsSelectTerrainModalOpen(true);

  const hideSelectTerrainModal = () => setIsSelectTerrainModalOpen(false);

  return (
    <div className="generate-dtm__empty-state">
      <Icon identifier={IconIdentifier.Terrain} size={78} />

      <div className="generate-dtm__empty-state__title">
        No data available to generate DTM.
      </div>

      <div className="generate-dtm__empty-state__description">
        To generate a DTM, load a point cloud layer or select a terrain.
      </div>

      <div className="generate-dtm__empty-state__actions">
        <Button onClick={handleOpenWorkspace}>Open Workspace</Button>
        <Tooltip
          className="map-3d-no-terrain-container__tooltip"
          hoverText="Please select a project to enable terrain selection."
          placement={Placement.Bottom} 
          activeState={!isNil(selectedProject)}
        >
          <Button
            onClick={showSelectTerrainModal}
            variant={ButtonVariant.Link}
            disabled={isNil(selectedProject)}
          >
            Select Terrain
          </Button>
        </Tooltip>
      </div>

      {isSelectTerrainModalOpen && (
        <SelectTerrainModal onHide={hideSelectTerrainModal} />
      )}
    </div>
  );
};
